module.exports = __webpack_public_path__ + "static/media/doubleFabric.361ddc04.jpg";